// extracted by mini-css-extract-plugin
module.exports = {"appLoader":"AppLoader_appLoader__ikhOd"};